import { useEffect, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

const ENDPOINTS = {
  nps: '/FormularioGlobalDashboard/ObterEvolucaoNps',
  likert: '/FormularioGlobalDashboard/ObterEvolucaoLikert',
  perguntas: '/FormularioGlobalDashboard/ObterEvolucaoPerguntas',
};

export default function useDashboardEvolucao(
  tipo,
  entidadeId,
  {
    enabled = true,
    filtros,
    onDadosCarregados,
    parametrosEvolucao,
    refreshToken = 0,
  } = {}
) {
  const [dados, setDados] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !entidadeId) {
      setDados(null);
      setIsLoading(false);
      return undefined;
    }

    let ativo = true;
    const carregarDados = async () => {
      setDados(null);
      setIsLoading(true);
      try {
        // A aplicação selecionada no dashboard não limita a evolução.
        const { formularioUsoId, ...filtrosEvolucao } = filtros || {};
        const response = await http.get(ENDPOINTS[tipo], {
          params: { entidadeId, ...filtrosEvolucao, ...parametrosEvolucao },
        });
        if (ativo) {
          setDados(response.data);
          onDadosCarregados?.(response.data);
        }
      } catch (err) {
        if (ativo && err?.response?.status !== 404) errorHandler(err);
      } finally {
        if (ativo) setIsLoading(false);
      }
    };

    carregarDados();
    return () => {
      ativo = false;
    };
  }, [
    tipo,
    entidadeId,
    enabled,
    filtros,
    onDadosCarregados,
    parametrosEvolucao,
    refreshToken,
  ]);

  return { dados, isLoading };
}
